import { ProductListItemProps, ProductListItemsFragment } from '@graphcommerce/magento-product'
import helpItemBg from '../../../assets/images/help_item_bg.png'

const handleNavigateClick = () => {
  window.open('https://calendly.com/templi-support', '_blank')
}

export const helpItem: ProductListItemsFragment &
  ProductListItemProps & { isHelpListItem?: boolean } = {
  __typename: 'SimpleProduct',
  uid: '',
  sku: null,
  name: null,
  url_key: null,
  design_id: null,
  production_time: null,
  setup_price: null,
  setup_price_discount: null,
  setup_price_quantity_threshold: null,
  setup_price_type: null,
  yotpo_average_rating: null,
  yotpo_review_count: null,
  min_tier_price: null,
  max_tier_price: null,
  moq: null,
  min_tier_max_unit_price: null,
  min_tier_min_unit_price: null,
  free_shipping: null,
  rating_summary: 0,
  compare_product_id: null,
  small_image: { url: helpItemBg?.src, label: 'Help' },
  price_range: {
    minimum_price: {
      regular_price: {
        currency: null,
        value: null,
      },
      discount: null,
      final_price: {
        currency: null,
        value: null,
      },
    },
  },
  price_tiers: null,
  source: null,

  // ProductListItemProps fields
  imageOnly: true, // assuming this comes from BaseProps
  sx: undefined,
  titleComponent: undefined,
  onClick: handleNavigateClick,
  isHelpListItem: true,
}
